import { render, staticRenderFns } from "./fvc-overview.vue?vue&type=template&id=5b1c910c&scoped=true"
import script from "./fvc-overview.vue?vue&type=script&lang=js"
export * from "./fvc-overview.vue?vue&type=script&lang=js"
import style0 from "./fvc-overview.vue?vue&type=style&index=0&id=5b1c910c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1c910c",
  null
  
)

export default component.exports